import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';

export const TaraPrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="relative min-h-screen bg-neutral-950 text-white overflow-hidden">
      <Navigation />
      <FloatingWhatsApp />

      <div className="pointer-events-none absolute inset-0">
        <div className="gradient-orb orb-1" />
        <div className="gradient-orb orb-2" />
        <div className="gradient-orb orb-3" />
        <div className="grain-overlay" />
      </div>

      <main className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 pt-28 pb-20">
        <section className="space-y-8">
          <header className="space-y-3">
            <p className="text-sm uppercase tracking-[0.35em] text-white/60">Tara</p>
            <h1 className="text-4xl sm:text-5xl font-semibold">Privacy Policy</h1>
            <p className="text-white/60">Last updated: January 31, 2026</p>
            <p className="text-white/70">
              Tara (&ldquo;we&rdquo;, &ldquo;us&rdquo;) provides a WhatsApp-based AI matchmaking service for adults (18+).
            </p>
          </header>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">Information We Collect</h2>
            <ul className="space-y-2 text-white/70 list-disc list-inside">
              <li>WhatsApp identifiers: phone number / WhatsApp ID.</li>
              <li>Profile data you provide: name, age, gender, city, intent, bio, preferences.</li>
              <li>Messages you send to Tara, including button responses.</li>
              <li>If you purchase tokens in the future, payment details will be handled by our payment processor; we do not store full card details.</li>
              <li>Photos, only after both parties mutually agree and are eligible.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">How We Use Information</h2>
            <ul className="space-y-2 text-white/70 list-disc list-inside">
              <li>Create and manage your profile.</li>
              <li>Match you with compatible users.</li>
              <li>Facilitate mutual consent, paid unlocks, and photo exchange.</li>
              <li>Improve service quality and safety.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">Legal Basis</h2>
            <p className="text-white/70">
              We process your data to provide the service you request and with your consent.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">Sharing</h2>
            <ul className="space-y-2 text-white/70 list-disc list-inside">
              <li>We share your profile or photos only after both users mutually agree.</li>
              <li>We do not sell your data.</li>
              <li>We may share limited data with payment processors solely to complete transactions.</li>
              <li>We may share data with service providers (hosting, messaging, payments) under strict confidentiality.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">Retention</h2>
            <ul className="space-y-2 text-white/70 list-disc list-inside">
              <li>We retain your data while your account is active.</li>
              <li>You can request deletion at any time (see Contact).</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">Security</h2>
            <ul className="space-y-2 text-white/70 list-disc list-inside">
              <li>We use reasonable technical and organizational measures to protect your data.</li>
              <li>No system is 100% secure; please use discretion.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">Age Requirement</h2>
            <p className="text-white/70">
              Tara is strictly for users 18 and above. We do not knowingly collect data from minors.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">Your Rights</h2>
            <ul className="space-y-2 text-white/70 list-disc list-inside">
              <li>Request access, correction, or deletion of your data.</li>
              <li>Opt out at any time by messaging &ldquo;STOP&rdquo; or contacting us.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-semibold">Contact</h2>
            <p className="text-white/70">Email: hey@pranshik.com</p>
          </section>
        </section>
      </main>
    </div>
  );
};
